import type { Client, RequestContext } from "../client";
import type { UseDefaultBranch, BranchSpecifier } from "../repositories/projectRepository";
import type { PaginatedCollection, GitBranchResource, GitTagResource, GitRef, ValidateGitRefV2Response, IIdName } from "../resources/index";
export class PlatformHubRepository {
    protected readonly client: Client;
    protected readonly context: RequestContext;
    constructor(client: Client, requestContext: RequestContext) {
        this.client = client;
        this.context = requestContext;
    }
    async tryGetBranch(defaultBranch: string, selectedRef: string): Promise<GitBranchResource | null> {
        function ShouldUseDefaultBranch(branch: BranchSpecifier): branch is typeof UseDefaultBranch {
            return typeof branch === "object";
        }
        try {
            const branchName: string = ShouldUseDefaultBranch(selectedRef) ? defaultBranch : selectedRef;
            return await this.client.get(this.context, "~/bff/platformhub/branches/{/name}", { name: branchName });
        }
        catch (ex) {
            if (ex.StatusCode === 404) {
                return null;
            }
            throw ex;
        }
    }
    getBranches() {
        return this.client.get<PaginatedCollection<GitBranchResource>>(this.context, "~/bff/platformhub/branches");
    }
    searchBranches(partialBranchName: string): Promise<PaginatedCollection<GitBranchResource>> {
        return this.client.get(this.context, "~/bff/platformhub/branches{?searchByName}", { searchByName: partialBranchName });
    }
    searchTags(partialBranchName: string): Promise<PaginatedCollection<GitTagResource>> {
        return this.client.get(this.context, "~/bff/platformhub/tags{?searchByName}", { searchByName: partialBranchName });
    }
    getTags(): Promise<PaginatedCollection<GitTagResource>> {
        return this.client.get(this.context, "~/bff/platformhub/tags");
    }
    validateGitRef(gitRef: GitRef): Promise<ValidateGitRefV2Response> {
        return this.client.post(this.context, "~/bff/platformhub/validate", { GitRef: gitRef });
    }
    createBranch(newBranchName: string, baseGitRef: GitRef): Promise<GitBranchResource> {
        return this.client.post<GitBranchResource>(this.context, "~/bff/platformhub/branches", { NewBranchName: newBranchName, BaseGitRef: baseGitRef });
    }
    getEnvironmentSummaries() {
        return this.client.get<EnvironmentSpaceInfo[]>(this.context, "~/bff/environments");
    }
    async requestTrial() {
        return await this.client.post(this.context, "~/bff/platformhub/request-platformhub-trial");
    }
}
export interface EnvironmentSpaceInfo {
    Id: string;
    Name: string;
    SpaceId: string;
    SpaceName: string;
}
export interface PlatformHubAccountSummary extends IIdName {
}
